export default {
  "Audio Compressor": "音訊壓縮",
  "HitPaw Online Audio Compressor": "壓縮音訊",
  "Reduce audio file size online without quality loss.": "線上無損壓縮音訊檔案",
  "Compress": "壓縮",
  "Compressing": "壓縮中",
  "Compressed Successfully": "壓縮成功",
  "Compress New": "壓縮新檔案",
  "Compression is complete": "壓縮完成",
  "Compression failed": "壓縮失敗",
  "Quality": "品質",
  "Format": "格式",
  "Add file": "添加檔案",
  "Output Settings": "輸出設置",

};
